import Granularity from "src/constants/granularity.enum";

export const APP_NAME = window.__RUNTIME_CONFIG__?.VITE_NAME ?? "Diamond App";
export const APP_BASENAME = window.__RUNTIME_CONFIG__?.VITE_BASENAME ?? "/app";
export const TIME_GRANULARITY =
  window.__RUNTIME_CONFIG__?.VITE_TIMEGRANULARITY === "FiveMinutes" ? Granularity.FiveMinutes : Granularity.OneMinute;
export const SUPERSET_DOMAIN = window.__RUNTIME_CONFIG__?.VITE_SUPERSET_DOMAIN ?? "";
export const API_URL = window.__RUNTIME_CONFIG__?.VITE_API_URL ?? "";
export const KEYCLOAK_DR_API_ROLES_CLAIM_NAME = `resource_access.${window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_API_CLIENTID}.roles`;
export const KEYCLOAK_APP_ROLES_CLAIM_NAME = `resource_access.${window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_CLIENT_ID}.roles`;

export const KEYCLOAK_ALLOWED_ORGANIZATION: string[] = (window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_ORGANIZATIONS ?? "")
  .replaceAll(" ", "")
  .split(",");

export const KEYCLOAK_AUTHORITY = window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_AUTHORITY ?? "";
export const KEYCLOAK_CLIENT_ID = window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_CLIENT_ID ?? "";
export const KEYCLOAK_REDIRECT_URI = window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_REDIRECT_URI ?? "";
export const KEYCLOAK_POST_LOGOUT_REDIRECT_URI = window.__RUNTIME_CONFIG__?.VITE_KEYCLOAK_POST_LOGOUT_REDIRECT_URI ?? "";
export const GOOGLE_MEASUREMENT_ID = window.__RUNTIME_CONFIG__?.VITE_GOOGLE_MEASUREMENT_ID ?? "";
export const VITE_SENTRY_DSN = window.__RUNTIME_CONFIG__?.VITE_SENTRY_DSN ?? "";
export const NUMBER_LOCALE = window.__RUNTIME_CONFIG__?.VITE_NUMBER_LOCALE ?? "de-CH";
export const CSV_DELIMITER = window.__RUNTIME_CONFIG__?.VITE_DEFAULT_CSV_DELIMITER ?? ",";

export const INCIDENTS_ENABLED = window.__RUNTIME_CONFIG__?.VITE_INCIDENTS_ENABLED === "true";
// Namespace is the first segment of the Keycloak client ID before "-app" (e.g. "arlas-app" → "arlas")
export const INCIDENTS_NAMESPACE = KEYCLOAK_CLIENT_ID.replace(/-app$/, "");

export const DEV = import.meta.env?.DEV;
